import React from 'react'
import Carousel from './Carousel/Carousel'

export default function Main() {
  return (
    <div>
      <Carousel/>
    </div>
  )
}
